module.exports = __webpack_public_path__ + "static/media/White_goods.df59fd32.svg";